import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import BackButton from 'components/back-button'
import themes, { extendTheme } from 'themes'
import { MobileBookingSummary } from 'pages/schedule/SelectLessonTime/redesign/booking-summary-card'
import SchedulePageBackground from 'pages/schedule/components/page-background'
import useChromeStyles, {
  PAGE_BACKGROUND,
} from 'pages/schedule/SelectLessonTime/redesign/styles'
import useStyles from './styles'

const refreshTheme = extendTheme(themes.offeringsRefresh)

// Same breakpoint the step 1 and step 2 redesigns use for their compact layout.
export const useIsCompact = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'))
}

// Page chrome shared by the redesigned step 3 variants (private lesson review
// and credit redemption): back link, compact summary on small screens, the main
// column and the sticky summary card on desktop. The visual progress bar is
// dropped like on steps 1 and 2; the step text stays for screen readers.
const ReviewFrameContent = ({
  lessonType,
  coach,
  facility,
  previousUrl,
  stepText,
  summaryCard,
  children,
}) => {
  const chrome = useChromeStyles()
  const classes = useStyles()
  const isCompact = useIsCompact()

  return (
    <SchedulePageBackground color={PAGE_BACKGROUND} className={chrome.page}>
      <div className={chrome.inner}>
        {isCompact ? (
          <div className={chrome.mobileTopCard}>
            <div className={chrome.mobileBackRow}>
              <BackButton previousUrl={previousUrl} />
            </div>
            <MobileBookingSummary
              lessonType={lessonType}
              coach={coach}
              facility={facility}
            />
          </div>
        ) : (
          <div className={chrome.desktopBack}>
            <BackButton previousUrl={previousUrl} />
          </div>
        )}
        {stepText && <span className={classes.srOnly}>{stepText}</span>}
        <div className={chrome.grid}>
          <div className={`${chrome.mainCol} ${classes.stack}`}>
            {typeof children === 'function'
              ? children({ isCompact })
              : children}
          </div>
          {!isCompact && <div className={chrome.sideCol}>{summaryCard}</div>}
        </div>
      </div>
    </SchedulePageBackground>
  )
}

ReviewFrameContent.propTypes = {
  lessonType: PropTypes.object.isRequired,
  coach: PropTypes.object.isRequired,
  facility: PropTypes.object,
  previousUrl: PropTypes.string,
  stepText: PropTypes.string,
  summaryCard: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
}

const ReviewFrame = props => (
  <ThemeProvider theme={refreshTheme}>
    <ReviewFrameContent {...props} />
  </ThemeProvider>
)

export default ReviewFrame
